<h1 matDialogTitle>Check TFG Rewards Voucher</h1>

<mat-dialog-content>
  <ng-container *ngIf="mode === 'VALIDATE'; else link">
    <p>
      Enter voucher number below:
    </p>

    <form class="dynamic-form" [formGroup]="form" style="width: 100%">
      <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Store</mat-label>
          <mat-select formControlName="storeId">
            <mat-option *ngFor="let store of stores" [value]="store.storeId">
              {{store.storeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Voucher Number</mat-label>
          <input matInput type="text" formControlName="voucherCode"
            autocomplete="new-password">
          <mat-hint align="end">15 characters of letters and numbers</mat-hint>
        </mat-form-field>

      </div>
    </form>

    <!-- <div style="margin-top: 16px;">
      <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="validate()">Validate Voucher</button>
    </div> -->
  </ng-container>

  <ng-template #link>
    <table style="width: 700px;">
      <tr><td>Voucher</td><td>{{form.controls['voucherCode'].value}}</td></tr>
      <tr><td>Valid</td><td>{{voucher.validVoucher ? 'Yes' : 'No'}}</td></tr>
      <tr><td>Message</td><td>{{voucher.errorMessage}}</td></tr>
      <tr><td>Start</td>{{voucher.voucherStart}}<td></td></tr>
      <tr><td>End</td><td>{{voucher.voucherEnd}}</td></tr>
      <tr><td>Status</td><td>{{voucher.voucherStatus}}</td></tr>
      <tr *ngIf="voucher.campaigns && voucher.campaigns.length === 1"><td>Campaign</td><td>{{voucher.campaigns[0].StoreDescription}}</td></tr>
    </table>
    <!-- <div style="margin-top: 16px;">
      <button mat-raised-button color="warn" (click)="reset()">Reset</button>
      <button style="margin-left: 16px;" [disabled]="!(voucher.validVoucher && voucher.campaigns && voucher.campaigns.length === 1)" mat-raised-button color="primary" (click)="linkVoucher()">Link Voucher</button>
    </div> -->

  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Cancel</button>

    <button *ngIf="mode === 'VALIDATE'" [disabled]="!form.valid" mat-raised-button color="primary" (click)="validate()">Validate Voucher</button>

    <button *ngIf="mode !== 'VALIDATE'" mat-raised-button color="warn" (click)="reset()">Reset</button>
    <button *ngIf="mode !== 'VALIDATE'" [disabled]="!(voucher.validVoucher && voucher.campaigns && voucher.campaigns.length === 1)" mat-raised-button color="primary" (click)="linkVoucher()">Link Voucher</button>
</mat-dialog-actions>
